import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { Box } from '@mui/material';
import Experience from './Experience';
import PersonalDetailsForm from './PersonalDetails';
import Portfolio from './Portfolio';
import StepIndicator from './StepIndicator';
import UploadCV from './UploadCV';
import { useNavigate } from 'react-router-dom';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF5722',
    },
    secondary: {
      main: '#4A4A4A',
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
});

const CandidateForm = () => {
  const navigate = useNavigate(); // Add this hook
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    primaryEmail: '',
    secondaryEmail: '',
    phoneNumber: '',
    countryCode: 'KE',
    gender: '',
    dateOfBirth: '',
    country: '',
    cvFile: null,
    seniority: '',
    primaryRoles: [],
    otherPrimaryRole: '',
    linkedinUrl: '',
    personalWebsiteUrl: '',
    figmaUrl: '',
    githubUrl: ''
  });

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleFinish = () => {
    console.log('Form completed:', formData);
    
    localStorage.removeItem('candidateFormData');
    localStorage.removeItem('portfolioProgress');
    localStorage.removeItem('portfolioData');
    localStorage.removeItem('portfolioForm');
    
    navigate('/cvs');
  };

  const handleSaveAndContinueLater = () => {
    const dataToSave = { ...formData };
    if (dataToSave.cvFile) {
      dataToSave.cvFile = {
        name: formData.cvFile.name,
        size: formData.cvFile.size,
        type: formData.cvFile.type,
        saved: true
      };
    }
    localStorage.setItem('candidateFormData', JSON.stringify(dataToSave));
    console.log('Form data saved:', dataToSave);
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <PersonalDetailsForm 
            formData={formData}
            setFormData={setFormData}
            onNext={handleNext}
            onBack={handleBack}
            onSaveAndContinueLater={handleSaveAndContinueLater}
            isFirstStep={true}
          />
        );
      case 1:
        return (
          <UploadCV 
            formData={formData}
            setFormData={setFormData}
            onNext={handleNext}
            onBack={handleBack}
            onSaveAndContinueLater={handleSaveAndContinueLater}
          />
        );
      case 2:
        return (
          <Experience 
            formData={formData}
            setFormData={setFormData}
            onNext={handleNext}
            onBack={handleBack}
            onSaveAndContinueLater={handleSaveAndContinueLater}
          />
        );
      case 3:
        return (
          <Portfolio 
            formData={formData}
            setFormData={setFormData}
            onFinish={handleFinish}
            onBack={handleBack}
            onSaveAndContinueLater={handleSaveAndContinueLater}
          />
        );
      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ 
        Height: '100vh', 
        backgroundColor: '#f8f9fa',
      }}>
        <StepIndicator activeStep={activeStep} />
        {renderStepContent(activeStep)}
      </Box>
    </ThemeProvider>
  );
};

export default CandidateForm;